export enum SegmentDataType {
    Text = 'Text',
    CompanyGLAccount = 'CompanyGLAccount',
    CompanyCustomData = 'CompanyCustomData',
    Enum = 'Enum',
}
